var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"chips",class:{ 'chips--active': _vm.active, 'chips--disabled': _vm.disabled }},_vm.$listeners),[(_vm.icon)?_c('i',{staticClass:"chips__icon",class:_vm.icon}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }